import React, { Component } from 'react';
import OnOffField from './OnOffField';

class InputWithCheckBox extends Component {
  static defaultProps = {
    onOffValue: '',
    placeholder: '',
    editedItem: {},
    fieldName: '',
    value: '',
    fieldType: 'text',
    onChange: () => {},
    changeOfEditedMultipItem: () => {},
    getCheckBoxFieldsObject: null,
  };

  render() {
    const checkboxFieldsObject = this.props.getCheckBoxFieldsObject();

    let ph =
      typeof this.props.placeholder === 'function'
        ? this.props.placeholder(this.props.editedItem)
        : this.props.placeholder;
    if (checkboxFieldsObject[this.props.fieldName + 'Orgin'] === undefined) {
      checkboxFieldsObject[this.props.fieldName + 'Orgin'] = this.props.value;
      checkboxFieldsObject[this.props.fieldName + 'Status'] =
        this.props.onOffValue === '' ? false : this.props.onOffValue;
    }
    let onOffValue = checkboxFieldsObject[this.props.fieldName + 'Status'];

    let readOnly = false;
    return (
      <div className='inputCheckBoxCombo'>
        <div className='figmaOnOffButtonBox'>
          <OnOffField
            value={onOffValue}
            onChange={(newValue) => {
              if (newValue === false) {
                this.props.changeOfEditedMultipItem([
                  { fieldName: this.props.fieldName + 'Status', newValue: newValue },
                  { fieldName: this.props.fieldName, newValue: checkboxFieldsObject[this.props.fieldName + 'Orgin'] },
                ]);
              } else {
                this.props.onChange(this.props.fieldName + 'Status', newValue);
              }
            }}
          />
        </div>
        {onOffValue ? (
          <input
            type={this.props.fieldType}
            className='w-100 form-control form-control-sm'
            placeholder={ph}
            autoFocus
            value={this.props.value === null ? '' : this.props.value}
            onChange={(e) => {
              let val = e.target.value;
              if (this.props.fieldType === 'number') {
                val = parseInt(val);
                if (Number.isNaN(val)) val = '';
              }
              this.props.onChange(this.props.fieldName, val);
            }}
            id={'htmlidfor' + this.props.fieldName}
            readOnly={readOnly}
            autoComplete='off'
          />
        ) : (
          <div className='inputFigma'></div>
        )}
      </div>
    );
  }
}

export default InputWithCheckBox;
